import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BixComfirmComponent } from './bix-comfirm.component';


@NgModule({
  declarations: [BixComfirmComponent],
  entryComponents:[BixComfirmComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [

    BixComfirmComponent
  ]
})
export class BixComfirmModule { }
